import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const MaterialAllocationModule = new Module({
  id: 'MATERIAL-ALLOCATION:VIEW:RESULT-TABLE',
  name: 'materialAllocationInOrder',
  path: 'material-allocation',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/MaterialAllocation'))
  ),
  actions: {
    deleteAllocatedMaterial: {
      id: 'MATERIAL-ALLOCATION:DELETE:ALLOCATED-MATERIAL',
      name: 'delete-allocated-material',
      label: 'Delete Allocated Material'
    },
    navigateToDispatchGroup: {
      id: 'MATERIAL-ALLOCATION:VIEW:NAVIGATE-TO-DISPATCH-GROUP',
      name: 'navigate-to-dispatch-group',
      label: 'View Details'
    },
    sendMail: {
      id: 'MATERIAL-ALLOCATION:VIEW:SEND-MAIL',
      name: 'send-mail',
      label: 'Send Mail'
    },
    downloadInvoice: {
      id: 'MATERIAL-ALLOCATION:VIEW:DOWNLOAD-MATERIAL',
      name: 'download-invoice',
      label: 'Download Invoice'
    },
    downloadPOD: {
      id: 'MATERIAL-ALLOCATION:VIEW:DOWNLOAD-POD',
      name: 'download-pod',
      label: 'Download POD'
    },
    deleteDispatchGroup: {
      id: 'MATERIAL-ALLOCATION:DELETE:DISPATCH-GROUP',
      name: 'delete-dispatch-group',
      label: 'Delete Dispatch Group'
    },
    returnDevices: {
      id: 'MATERIAL-ALLOCATION:RETURN-DEVICES',
      name: 'return-devices',
      label: 'File Devices Return'
    },
    seeReturnBatch: {
      id: 'MATERIAL-ALLOCATION:SEE-RETURN-BATCH',
      name: 'see-return-batch',
      label: 'See Return Batch'
    }
  }
});

export default new ModuleBundle('MaterialAllocation', [
  MaterialAllocationModule
]);
